(function () {
  'use strict';

  function initRoot(root) {
    if (!root || typeof Swiper === 'undefined') return;
    var el = root.querySelector('.home-blog-swiper');
    if (!el) return;
    if (el.swiper) return;

    var slideCount = el.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
    if (slideCount < 1) return;

    var prevEl = root.querySelector('.swiper-button-prev');
    var nextEl = root.querySelector('.swiper-button-next');

    var useLoop = slideCount >= 2;
    var reduceMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 24,
      watchOverflow: !useLoop,
      resistanceRatio: 0.65,
      loop: useLoop,
      loopAdditionalSlides: useLoop ? 1 : 0,
      speed: 500,
      autoplay:
        slideCount >= 2 && !reduceMotion
          ? {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 12,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 12,
        },
      },
    });
  }

  function destroyInTarget(target) {
    if (!target) return;
    var root = target.querySelector('[data-home-blog-posts-swiper]');
    if (!root) return;
    var el = root.querySelector('.home-blog-swiper');
    if (el && el.swiper) el.swiper.destroy(true, true);
  }

  function initAll() {
    document.querySelectorAll('[data-home-blog-posts-swiper]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-home-blog-posts-swiper]');
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyInTarget(event.target);
  });
})();
